<template>
  <div id="app">
    <!-- 全局头部 -->
    <Header />

    <!-- 主要内容区域 -->
    <main class="main-content">
      <router-view />
    </main>

    <!-- 全局页脚 -->
    <Footer />

    <!-- 右侧悬浮导航 -->
    <FloatingNav />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import FloatingNav from '@/components/FloatingNav.vue'

export default {
  name: 'App',

  components: {
    Header,
    Footer,
    FloatingNav
  }
}
</script>

<style lang="scss">
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding-top: 0;
}
</style>
